import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './Team.css';
import { FaLinkedin, FaInstagram, FaGithub } from 'react-icons/fa';
 
import adityaPhoto from '../assets/team/aditya.jpg';
import amitPhoto from '../assets/team/amit.jpg';
import swarwelPhoto from '../assets/team/swarwel.jpeg';
import tejasPhoto from '../assets/team/tejas.jpg';
import premPhoto from '../assets/team/prem.png';
import riteshPhoto from '../assets/team/ritesh.jpg';

import aniruddhaPhoto from '../assets/team/aniruddha.jpg';
import ishankPhoto from '../assets/team/ishank.jpg';
import poonamPhoto from '../assets/team/poonam.jpeg';
import riyaPhoto from '../assets/team/riya.jpeg';
import purvaPhoto from '../assets/team/purva.jpg';
import yashPhoto from '../assets/team/yash.png';
import samruddhiPhoto from '../assets/team/samruddhi.jpg';
import divyaPhoto from '../assets/team/divya.jpeg';
import kunjalPhoto from '../assets/team/kunjal.jpeg';
import shreyaPhoto from '../assets/team/shreya.jpg';
import shrutikaPhoto from '../assets/team/shrutika.png';
import falguniPhoto from '../assets/team/falguni.jpg';
import gunjanPhoto from '../assets/team/gunjan.jpeg';
import tannuPhoto from '../assets/team/tannu.jpg';
import sanchiPhoto from '../assets/team/sanchi.jpg';
import shivangiPhoto from '../assets/team/shivangi.jpg';

const allTeamMembers = [
  // Core Team Members
  { id: 1, name: 'Mr. Aditya Karanjekar', role: 'Chairperson', photo: adityaPhoto, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/aditya-karanjekar-83838a258/', instagram: 'https://www.instagram.com/karanjekar_aditya/', github: '#' } },
  { id: 2, name: 'Mr. Amit Taksande', role: 'Vice Chairperson', photo: amitPhoto, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/amit-taksande-841153258/', instagram: '#', github: '#' } },
  { id: 3, name: 'Mr. Swarwel Dorle', role: 'Secretary', photo: swarwelPhoto, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/swarwel-dorle-953318297/', instagram: '#', github: '#' } },
  { id: 4, name: 'Mr. Tejas Choudhari', role: 'Treasurer', photo: tejasPhoto, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/tejas-choudhari-99a706342/', instagram: 'https://www.instagram.com/tejas_446/', github: '#' } },
  { id: 5, name: 'Mr. Prem Rahangdale', role: 'Webmaster', photo: premPhoto, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/prem-rahangdale-1b5375246/', instagram: 'https://www.instagram.com/prem789k/', github: 'https://github.com/prem789k-coder' } },
  { id: 6, name: 'Mr. Ritesh Dhakulkar', role: 'Membership-Chair', photo: riteshPhoto, category: 'Core Team', social: { linkedin: 'https://www.linkedin.com/in/riteshdhakulkar/', instagram: 'https://www.instagram.com/riteshhd_/', github: '#' } },

  // Heads & Members
  { id: 7, name: 'Ms. Poonam Walale', role: 'Head Editorial Team', photo: poonamPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/poonamwalale/', instagram: 'https://www.instagram.com/poonam_walale_0701/', github: '#' } },
  { id: 8, name: 'Ms. Riya Dodke', role: 'Head Event Management Team', photo: riyaPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/riya-dodke-934647287/', instagram: 'https://www.instagram.com/riya_dodke_01/', github: '#' } },
  { id: 9, name: 'Ms. Purva Manusmare', role: 'Head Social Media Team', photo: purvaPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/purva-manusmare-06ab0b315/', instagram: 'https://www.instagram.com/purva_manusmare/', github: '#' } },
  { id: 10, name: 'Mr. Ishank Ikhare', role: 'Head Logistics Team', photo: ishankPhoto, category: 'Web Team', social: { linkedin: '#', instagram: 'https://www.instagram.com/i.b._marketing/', github: '#' } },
  { id: 11, name: 'Mr. Aniruddha Mankar', role: 'Head Web Team', photo: aniruddhaPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/aniruddhamankar/', instagram: '#', github: '#' } },
  { id: 12, name: 'Ms. Divya Katkurwar', role: 'Head Public Relation Team', photo: divyaPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/divya-katkurwar-691389262/', instagram: 'https://www.instagram.com/_divya_katkurwar_/', github: '#' } },
  { id: 13, name: 'Ms. Samruddhi Maske', role: 'Member Editorial Team', photo: samruddhiPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/samruddhi-maske-6a0bb5379/', instagram: 'https://www.instagram.com/maske_samruddhi15/', github: '#' } },
  { id: 14, name: 'Ms. Kunjal Pardhi', role: 'Member Event Management Team', photo: kunjalPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/kunjal-pardhi-3558a6323/', instagram: 'https://www.instagram.com/kunjal_pardhi/', github: '#' } },
  { id: 15, name: 'Ms. Shreya Nege', role: 'Member Event Management Team', photo: shreyaPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/shreya-nege-a9b36336a/', instagram: '#', github: '#' } },
  { id: 16, name: 'Ms. Shrutika Manwatkar', role: 'Member Social Media Team', photo: shrutikaPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/shrutika-manwatkar-a99147372/', instagram: 'https://www.instagram.com/shrutika_1310o/', github: '#' } },
  { id: 17, name: 'Mr. Yash Wadbude', role: 'Member Logistics Team', photo: yashPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/yash-wadbude-929494315/', instagram: 'https://www.instagram.com/yash_wadbude._/', github: '#' } },
  { id: 18, name: 'Ms. Falguni Newalkar', role: 'Member Web Team', photo: falguniPhoto, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } },
  { id: 19, name: 'Ms. Gunjan Fartade', role: 'Member Public Relation Team', photo: gunjanPhoto, category: 'Web Team', social: { linkedin: '#', instagram: 'https://www.instagram.com/gunjanfartade17/', github: '#' } },
  { id: 20, name: 'Ms. Tannu Singh', role: 'Member Public Relation Team', photo: tannuPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/tannu-singh-9509b2361/', instagram: 'https://www.instagram.com/tannu.7633/', github: '#' } },
  { id: 21, name: 'Ms. Sanchi Muneshwar', role: 'Member', photo: sanchiPhoto, category: 'Web Team', social: { linkedin: 'https://www.linkedin.com/in/sanchi-muneshwar-530a15316/', instagram: 'https://www.instagram.com/sanchi_muneshwar358/', github: '#' } },
  { id: 22, name: 'Ms. Shivangi Yadav', role: 'Member', photo: shivangiPhoto, category: 'Web Team', social: { linkedin: '#', instagram: '#', github: '#' } }
];


// This is a reusable card component for a single team member.
const TeamMemberCard = ({ member }) => (
  <div className="team-card">
    <img src={member.photo} alt={member.name} className="member-photo" />
    <h3 className="member-name">{member.name}</h3>
    <p className="member-position">{member.role}</p>
    <div className="social-links">
      {member.social.linkedin && member.social.linkedin !== '#' && (
        <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
      )}
      {member.social.instagram && member.social.instagram !== '#' && (
        <a href={member.social.instagram} target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
      )}
      {member.social.github && member.social.github !== '#' && (
        <a href={member.social.github} target="_blank" rel="noopener noreferrer"><FaGithub /></a>
      )}
    </div>
  </div>
);

const Team = () => {
  // Get the category from the URL (e.g., 'core-team' or 'web-team')
  const { teamCategory } = useParams();

  const [filteredMembers, setFilteredMembers] = useState([]);
  const [title, setTitle] = useState('Core Team');

  // This effect runs when the page loads or when the URL category changes.
  useEffect(() => {
    let membersToDisplay = [];
    let newTitle = '';

    if (teamCategory === 'web-team') {
      newTitle = 'Heads & Members';
      membersToDisplay = allTeamMembers.filter(member => member.category === 'Web Team');
    } else {
      // Default to 'Office Bearers' for any other URL, including /team and /team/core-team
      newTitle = 'Office Bearers';
      membersToDisplay = allTeamMembers.filter(member => member.category === 'Core Team');
    }

    setTitle(newTitle);
    setFilteredMembers(membersToDisplay);
  }, [teamCategory]); // This dependency array ensures the code re-runs when the URL changes.

  return (
    <div className="section-container">
      <h2 className="section-title">{title}</h2>
      <div className="team-grid">
        {filteredMembers.map((member) => (
          <TeamMemberCard key={member.id} member={member} />
        ))}
      </div>
    </div>
  );
};

export default Team;
